import MapSyntaxReducer from "./map-syntax-reducer";
import reducer from "shift-reducer";
import {List} from "immutable";
import {Enforester} from "./enforester";
import Syntax from "./syntax";
import  * as _ from "ramda";
import {Maybe} from "ramda-fantasy";
const Just_335 = Maybe.Just;
const Nothing_336 = Maybe.Nothing;
const symWrap_337 = Symbol("wrapper");
const symName_338 = Symbol("name");
const isKind_339 = _.curry((kind_353, t_354, v_355) => {
  if (t_354 instanceof Syntax) {
    return t_354[kind_353]() && (v_355 == null || t_354.val() == v_355);
  }
});
const isKeyword_340 = isKind_339("isKeyword");
const isIdentifier_341 = isKind_339("isIdentifier");
const isNumericLiteral_342 = isKind_339("isNumericLiteral");
const isStringLiteral_343 = isKind_339("isStringLiteral");
const isNullLiteral_344 = isKind_339("isNullLiteral");
const isPunctuator_345 = isKind_339("isPunctuator");
const isRegularExpression_346 = isKind_339("isRegularExpression");
const isBraces_347 = isKind_339("isBraces");
const isBrackets_348 = isKind_339("isBrackets");
const isParens_349 = isKind_339("isParens");
const isDelimiter_350 = isKind_339("isDelimiter");
const getLineNumber_351 = t_356 => {
  if (t_356 instanceof Syntax) {
    return t_356.lineNumber();
  }
  throw new Error("Line numbers on terms not implemented yet");
};
const getVal_352 = t_357 => {
  if (isDelimiter_350(t_357, null)) {
    return null;
  }
  if (t_357 instanceof Syntax) {
    return t_357.val();
  }
  return null;
};
export class SyntaxOrTermWrapper {
  constructor(s_358, context_359 = {}) {
    this[symWrap_337] = s_358;
    this.context = context_359;
  }
  isKeyword(value_360) {
    return isKeyword_340(this[symWrap_337], value_360);
  }
  isIdentifier(value_361) {
    return isIdentifier_341(this[symWrap_337], value_361);
  }
  isNumericLiteral(value_362) {
    return isNumericLiteral_342(this[symWrap_337], value_362);
  }
  isStringLiteral(value_363) {
    return isStringLiteral_343(this[symWrap_337], value_363);
  }
  isNullLiteral(value_364) {
    return isNullLiteral_344(this[symWrap_337], value_364);
  }
  isPunctuator(value_365) {
    return isPunctuator_345(this[symWrap_337], value_365);
  }
  isRegularExpression(value_366) {
    return isRegularExpression_346(this[symWrap_337], value_366);
  }
  isBraces(value_367) {
    return isBraces_347(this[symWrap_337], value_367);
  }
  isBrackets(value_368) {
    return isBrackets_348(this[symWrap_337], value_368);
  }
  isParens(value_369) {
    return isParens_349(this[symWrap_337], value_369);
  }
  isDelimiter(value_370) {
    return isDelimiter_350(this[symWrap_337], value_370);
  }
  lineNumber() {
    return getLineNumber_351(this[symWrap_337]);
  }
  val() {
    return getVal_352(this[symWrap_337]);
  }
  inner() {
    let stx_371 = this[symWrap_337];
    if (!isDelimiter_350(stx_371, null)) {
      throw new Error("Can only get inner syntax on a delimiter");
    }
    let enf_372 = new Enforester(stx_371.inner(), List(), this.context);
    return new MacroContext(enf_372, "inner", this.context);
  }
}
export function unwrap(x_373) {
  if (x_373 instanceof SyntaxOrTermWrapper) {
    return x_373[symWrap_337];
  }
  return x_373;
}
export default class MacroContext {
  constructor(enf_374, name_375, context_376, useScope_377, introducedScope_378) {
    this._enf = enf_374;
    this[symName_338] = name_375;
    this.context = context_376;
    if (useScope_377 && introducedScope_378) {
      this.noScopes = false;
      this.useScope = useScope_377;
      this.introducedScope = introducedScope_378;
    } else {
      this.noScopes = true;
    }
    this[Symbol.iterator] = () => this;
  }
  name() {
    return new SyntaxOrTermWrapper(this[symName_338], this.context);
  }
  next(type_379 = "Syntax") {
    if (this._enf.rest.size === 0) {
      return {done: true, value: null};
    }
    let value_380;
    switch (type_379) {
      case "AssignmentExpression":
      case "expr":
        value_380 = this._enf.enforestExpressionLoop();
        break;
      case "Expression":
        value_380 = this._enf.enforestExpression();
        break;
      case "Syntax":
        value_380 = this._enf.advance();
        if (!this.noScopes) {
          value_380 = value_380.addScope(this.useScope).addScope(this.introducedScope, this.context.bindings, {flip: true});
        }
        break;
      default:
        throw new Error("Unknown term type: " + type_379);
    }
    return {done: false, value: new SyntaxOrTermWrapper(value_380, this.context)};
  }
}
